<template>
  <div>
    <div class="news-top"></div>
    <div class="page_padding">
      <bread-crumb :path="$route"></bread-crumb>
    </div>
    <div class="title marginT"><span class="fontBold font41">FAQ</span></div>
    <div class="page_padding marginB">
      <div
        v-for="(value, index) in faqList"
        :key="index"
        class="box"
        :class="{open: faqList[index].isOpen}"
        @click="showAnswer(index)"
      >
        <div class="question" :class="{open: faqList[index].isOpen}">
          <div class="mark question-mark">Q</div>
          <div class="question-content">
            {{ faqList[index].question }}
          </div>
          <div class="arrow" :class="{['arrow-open']: faqList[index].isOpen}">
            <span>〈</span>
          </div>
        </div>
        <div class="answer-wrapper">
          <div
            v-show="faqList[index].isOpen"
            class="answer"
            v-for="(item, key) in value.answer"
            :key="key"
          >
            <div class="mark answer-mark">
              A{{ value.answer.length > 1 ? key + 1 : "" }}
            </div>
            <div class="question-content">
              {{ value.answer[key] }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "../../components/BreadCrumb.vue";
export default {
  components: {BreadCrumb},
  data() {
    return {
      openIndex: null,
      isOpenAnswer: false,
      faqList: [
        {
          question: "CMS 홈페이지 로그인을 어떻게 하나요?",
          answer: [
            "해피테이블 최초 설치시 기관관리자에게 URL,ID,PW를 전송해드립니다. 분실시 카카오채널 '해피테이블'로 연락 주세요.",
          ],
          isOpen: false,
        },
        {
          question: "CMS 홈페이지 ID,PW 정보를 잊어버렸어요.",
          answer: ["카카오채널 '해피테이블' 로 상담을 통해 확인 가능합니다."],
          isOpen: false,
        },
        {
          question: "스크린샷을 출력하는 방법이 어떻게 되나요?",
          answer: [
            "활동관리 > 게임 > 하단의 게임활동 > 하단의 회원 갤러리 내용 클릭 후 출력 가능합니다.",
          ],
          isOpen: false,
        },
        {
          question: "해피테이블 로그인은 왜 해야 하나요?",
          answer: [
            "해피테이블 로그인을 통해 콘텐츠를 진행해야 게임 데이터를 저장할 수 있고 CMS를 통해 내용 조회가 가능합니다.",
          ],
          isOpen: false,
        },
        {
          question: "해피테이블 회원가입을 했는데 로그인이 안됩니다.",
          answer: [
            "(회원정보를 확인표시가 뜰 경우) 회원 등록시 '전화번호' 에 입력한 번호가 해피테이블 로그인 아이디가 됩니다. 확인하시고 로그인 부탁드립니다.",
            "(네트워크 오류가 뜰 경우) 와이파이가 연결이 안된 경우입니다. 카카오채널 '해피테이블' 채팅상담을 통해 해결해드리겠습니다.",
          ],
          isOpen: false,
        },
        {
          question: "해피테이블을 물티슈나 물수건으로 닦아도 되나요?",
          answer: [
            "가능합니다. 단, 물자국이 남으면 사용에 지장이 되니 마른수건으로 다시 닦는 것을 권장드립니다.",
          ],
          isOpen: false,
        },
      ],
    };
  },
  methods: {
    showAnswer(index) {
      this.faqList[index].isOpen = !this.faqList[index].isOpen;
    },
  },
};
</script>

<style scoped>
.title {
  margin-bottom: 90px;
}
.mark {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  color: white;
  font-weight: bold;
  font-size: 24px;
}
.question-mark {
  background-color: lightgrey;
}
.question-content {
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  margin-left: 30px;
  margin-right: 10px;
  line-height: 1.5rem;
}
.open.question {
  border-bottom: 1px solid #ababab;
  padding-bottom: 16px;
}
.answer-mark {
  background-color: #3d3d3d;
}
.question {
  padding: 16px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.answer {
  padding: 5px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.box:nth-child(2) {
  padding-top: 20px;
}
.open.question .mark {
  background-color: #ff5230;
}
.question {
  padding: 0;
}
.box {
  padding: 17px 30px;
  border: 1px solid #d5d5d5;
  margin-bottom: 20px;
}
.a {
  border: 1px solid lightgrey;
}
.arrow {
  width: 20px;
  margin-left: auto;
  transform: rotate(-90deg);
}
.arrow span {
  color: #0a0a0a;
  font-size: 20px;
}
.arrow-open {
  transform: rotate(-270deg);
}
.box.open {
  border: 1px solid #ababab;
}
.box.open .answer-wrapper {
  padding-top: 11px;
}
@media (max-width: 1200px) {
  .box {
    padding: 15px 20px;
    border: 1px solid #d5d5d5;
    margin-bottom: 20px;
  }
  .question-content {
    font-size: 14px;
    margin-left: 10px;
    width: calc(100% - 90px);
  }
  .mark {
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    color: white;
    font-weight: bold;
    font-size: 18px;
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .title.marginT {
    margin-top: 100px !important;
    margin-bottom: 90px;
  }
}
@media (max-width: 767px) {
  .title.marginT {
    margin-top: 100px !important;
    margin-bottom: 30px;
  }
  .news-top {
    padding-top: 0 !important;
  }
}
</style>
